import * as Sentry from "@sentry/react";
// <-- Core imports -->
Sentry.init({
  dsn: "https://33529618683fc941859fb045ef77b9b8@o4506944600276992.ingest.us.sentry.io/4506945083015168",
  environment: MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration()
  ],
  tracePropagationTargets: [
    /^https:\/\/api\.go-2-work\.com\//, 
    /^https:\/\/api\.staging.go2work\.com\//,
    /^https:\/\/api\.go2work\.com\//,
    /^https:\/\/api\.revenuecat\.com\//,
  ],
  tracesSampleRate: 1.0,
  profilesSampleRate: 1.0,
});

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useEffect } from "react";

import { createRoot } from "react-dom/client";
import { pdfjs } from "react-pdf";
import { Provider } from "react-redux";
import { BrowserRouter, useLocation } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

// <-- Store imports -->
import { store } from "@/store";

// <-- Configuration Imports -->
import "./i18n/index";

// <-- Styles imports -->
import "@/styles/globals.css";

// <-- Components imports -->
import App from "./App";
import { Toaster } from "./components/ui/toaster";
import PermissionDialog from "./components/PermissionDialog";
import MixpanelProvider from "./providers/MixpanelProvider";
import { MODE } from "./config/vars";

const queryClient = new QueryClient();

const root = createRoot(document.getElementById("root"));

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <MixpanelProvider>
            <ScrollToTop />
            <App />
            <Toaster />
            <PermissionDialog />
          </MixpanelProvider>
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
